import React from "react";
import { useState } from "react";
import "./machnav.css";

const tabs = [
  "Cricket",
  "Football",
  "Tennis",
  "Esoccer",
  "Horse Racing",
  "Greyhound Racing",
  "Table Tennis",
  "Basketball",
  "Boxing",
  "Mixed Martial Arts",
  "American Football",
];

const GamesNav = () => {
  const [activeTab, setActiveTab] = useState("Cricket");

  return (
    <>
      <div className="overflow-x-auto whitespace-nowrap hidden md:flex">
        <div className="flex w-[99.5%] tb">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(tab)}
              className={`text-sm w-[9%] !py-[5px] !px-2 border-l border-[#000] min-w-max whitespace-nowrap font-medium ${
                activeTab === tab
                  ? "bg-[#2C3E50] text-white border-l border-[#2C3E50]"
                  : "bg-[#CCCCCC] text-black"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default GamesNav;
